import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { store, loadStore } from "store";
var RegisterDeviceView = /** @class */ (function (_super) {
    tslib_1.__extends(RegisterDeviceView, _super);
    function RegisterDeviceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.company = "";
        _this.userCompany = "";
        _this.region = null;
        _this.countries = null;
        _this.selectNewCompany = false;
        _this.selectedCountryId = null;
        _this.selectedDealerId = null;
        _this.loading = false;
        _this.requestMessage = "";
        return _this;
    }
    RegisterDeviceView.prototype.mounted = function () {
        if (!this.fieldsLocked) {
            this.getCountries();
            this.$watch("selectedCountryId", this.setRegionInfo);
            this.setUserCompany();
        }
    };
    RegisterDeviceView.prototype.sendDeviceRequest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.requestMessage = "Sending";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.post("user/requestdevice", { token: store.sessionToken, serialNumber: this.device.serial })];
                    case 2:
                        data = (_b.sent()).data;
                        this.requestMessage = data ? this.$t("registerDeviceView.sended").toString() : this.$t("registerDeviceView.sendFailed").toString();
                        if (data) {
                            this.device.isPending = true;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.requestMessage = this.$t("registerDeviceView.sendFailed").toString();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RegisterDeviceView.prototype, "fieldsLocked", {
        get: function () {
            return this.device.hasCustomerInformation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegisterDeviceView.prototype, "requiredFieldsFilled", {
        get: function () {
            return (this.selectedCountryId && this.selectedDealerId && (!this.selectNewCompany || this.company.length > 0)) || this.fieldsLocked;
        },
        enumerable: true,
        configurable: true
    });
    RegisterDeviceView.prototype.getCountries = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("user/countries")];
                    case 1:
                        _a.countries = (_b.sent()).data;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterDeviceView.prototype.setUserCompany = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("devices/userCompany", { params: { token: store.sessionToken } })];
                    case 1:
                        data = (_a.sent()).data;
                        this.userCompany = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterDeviceView.prototype.setRegionInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedDealerId = null;
                        return [4 /*yield*/, axios.get("dealers/regions/" + this.selectedCountryId)];
                    case 1:
                        data = (_a.sent()).data;
                        this.region = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterDeviceView.prototype.registerDevice = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, axios.post("devices/registerDevice", {
                                serialNumber: this.device.serial,
                                token: store.sessionToken,
                                company: this.company,
                                regionId: this.selectedCountryId,
                                dealerId: this.selectedDealerId
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("registerDeviceView.errorRegisteringDevice") })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, loadStore()];
                    case 5:
                        _a.sent();
                        this.$router.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], RegisterDeviceView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], RegisterDeviceView.prototype, "product", void 0);
    RegisterDeviceView = tslib_1.__decorate([
        Component
    ], RegisterDeviceView);
    return RegisterDeviceView;
}(Vue));
export default RegisterDeviceView;
